module.exports = __webpack_public_path__ + "static/media/SentinelX_logo_light.b8660fc1.png";